import { render, staticRenderFns } from "./AgreementSidebar.vue?vue&type=template&id=2621aeaf&"
import script from "./AgreementSidebar.vue?vue&type=script&lang=js&"
export * from "./AgreementSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AgreementSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports